import { jsx } from "react/jsx-runtime";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { validateTidalLicense } from "../../base/index.js";
function BorderColor(props) {
  return /* @__PURE__ */ jsx(
    BorderColorIcon,
    {
      "data-testid": "BorderColor",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "BorderColor",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
BorderColor.tidalIconMeta = {
  categories: "common,navigation",
  name: "BorderColor"
};
validateTidalLicense();
export {
  BorderColor
};
//# sourceMappingURL=BorderColor.js.map
